import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import { getUserByToken } from '@/api';
import App from './App.vue';
import router from './router/router';
import store from './store/store';
import './registerServiceWorker';
import * as echarts from 'echarts';
import dataTool from 'echarts/extension/dataTool';
import 'font-awesome/css/font-awesome.css';
import './styles/style.scss';
import VuePerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
 
// 挂载接口配置表
// import index from "./api/index";
// Vue.prototype._apis = index;

Vue.prototype.$echarts = echarts;
Vue.prototype.$dataTool = dataTool;
Vue.prototype.$baseImageUrl = '/temporary/';
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VuePerfectScrollbar);
Vue.prototype.baseUrl = `http://${document.domain}:${location.port}`;
if (localStorage.getItem('access_token')) {
  store.commit('setToken', localStorage.getItem('access_token'));
}
// getUserByToken().then((res) => {
//   console.log(res);
//   // this.islogin = true
//   // this.username = res.data.userName
//   store.commit('setUserInfo', res.data);
//   store.commit('setLoginFlag', true);
//   if (res.data.userType == 9) {
//     store.commit('setIsUserAdmin', true);
//   } else {
//     store.commit('setIsUserAdmin', false);
//   }
//   if (res.data.userType == 7) {
//     store.commit('setIsRemAdmin', true);
//   } else {
//     store.commit('setIsRemAdmin', false);
//   }
// });
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
